import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { MdCardMembership, MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaBriefcase, FaGift, FaInfinity } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";
import { motion } from "framer-motion";
import {
  FaSearchDollar,
  FaThumbsUp,
  FaShieldAlt,
  FaMousePointer,
  FaWpforms,
  FaFileUpload,
  FaTruck,
} from "react-icons/fa";
import {
  FaMoneyBillWave,
  FaRegHandshake,
  FaReceipt,
  FaMedal,
  FaLayerGroup,
  FaGlobeAmericas,
} from "react-icons/fa";
import {
  FaMoneyCheckAlt,
  FaClipboardCheck,
  FaBalanceScale,
  FaWallet,
  FaTags,
} from "react-icons/fa";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const CashBack = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Cash Back")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question:
        "What is the typical cashback percentage offered on these cards?",
      answer:
        " Cashback percentages vary by card and category. Basic cards may offer 1–2% across all spends, while premium cards may offer 5–10% on categories like fuel, groceries, or e-commerce.",
    },
    {
      question: " Do cashback rewards expire?",
      answer:
        " Generally, cashback credited as statement credit does not expire. However, some banks may apply expiry policies on accumulated cashback if not redeemed in time—check your card’s T&Cs.",
    },
    {
      question: "How is cashback credited—instantly or monthly?",
      answer:
        " It depends on the issuer. Some cards offer real-time cashback while others credit it at the end of the billing cycle or post reaching a minimum threshold.",
    },
    {
      question: "Are there any exclusions where cashback is not earned?",
      answer:
        " Yes. Most cards do not offer cashback on rent payments, wallet loads, cash advances, and government transactions like taxes or fines.",
    },

    {
      question: "Can I have multiple cashback cards?",
      answer:
        " Yes, you can hold multiple cashback cards. In fact, many savvy users optimize their benefits by using different cards for different spend categories.",
    },
    {
      question: "Which is better cashback or rewards?",
      answer:
        "While both cashback and rewards offer incentives, cashback is straightforward, providing a direct cash benefit. Rewards points, however, may require additional steps to redeem and can often be converted into miles or other benefits. The choice depends on your preference for simplicity or potential value in reward redemption.",
    },
    {
      question: "Are these cards beneficial for low spenders too?",
      answer:
        "Absolutely. Even modest monthly spending on essentials can generate meaningful cashback. Look for cards with no annual fee and universal cashback structures for better ROI.",
    },
    {
      question: "Is TheFinMaster.com a credit card issuer?",
      answer:
        " No. TheFinMaster.com is a fintech aggregator platform that provides educational content, comparisons, and in-depth analysis to help users choose the best financial products. Once you find the right cashback credit card, we redirect you to the issuing bank’s official page to complete the application process.",
    },
    {
      question: "Can I redeem cashback directly into my bank account?",
      answer:
        "Most cashback credit cards auto-adjust the cashback earned against your upcoming statement balance. However, some cards allow transferring cashback to your savings account or digital wallets, depending on issuer policy.",
    },
    {
      question: "Is there a cap on monthly or annual cashback earnings?",
      answer:
        "Yes, many cashback cards have monthly or annual limits on how much cashback you can earn. These caps vary by card and category, so it's important to check the terms before applying.",
    },
    {
      question: "Do I need to meet a minimum spend to earn cashback?",
      answer:
        "Some cashback credit cards require a minimum transaction amount or monthly spend threshold to qualify for cashback rewards, especially for high-percentage cashback categories.",
    },
    {
      question: "Are utility bill payments eligible for cashback?",
      answer:
        "It depends on the card. While some cards offer cashback on utility bill payments, others may exclude such transactions or offer reduced cashback rates on them.",
    },
    {
      question: "Do fuel purchases earn cashback on these cards?",
      answer:
        "Most cashback cards exclude fuel purchases from cashback eligibility but may provide a fuel surcharge waiver. Always read the fine print to know what’s included.",
    },
    {
      question: "Can cashback be earned on international transactions?",
      answer:
        "Some cashback credit cards allow cashback on international purchases, but they may be offset by high foreign transaction fees. Specialized travel or international cards may be more rewarding for such spends.",
    },
    {
      question: "How can I track my cashback earnings?",
      answer:
        "You can track your cashback through monthly credit card statements, mobile banking apps, or internet banking portals, where issuers usually show earnings and pending credits clearly.",
    },
    {
      question: "Is cashback taxable?",
      answer:
        "No, cashback earned on credit card transactions is generally not considered taxable income in India, as it is treated as a discount on spending rather than earnings.",
    },
    {
      question: "What happens to cashback if I return a product?",
      answer:
        "If you return a product and the transaction is reversed, the corresponding cashback will also be reversed or deducted from your future cashback earnings.",
    },
    {
      question: "Can I convert cashback to rewards points or vouchers?",
      answer:
        "Typically, cashback is credited as a statement balance adjustment. However, some cards offer hybrid features allowing conversion to vouchers or reward points for additional value.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  const steps = [
    {
      icon: <FaShieldAlt className="h-6 w-6 text-purple-600" />,
      title: "Check Eligibility  Criteria",
      description:
        " Make sure you fulfill the basic eligibility conditions such as income bracket, age, and credit score requirements set by the issuing bank.",
    },
    {
      icon: <FaMousePointer className="h-6 w-6 text-teal-500" />,
      title: "Fill Out the Application Form",
      description:
        " Once you’ve picked your preferred card, fill in your personal, residential, and income details as required.",
    },
    {
      icon: <FaWpforms className="h-6 w-6 text-amber-500" />,
      title: "Submit the Required Documents",
      description:
        " Upload essential KYC documents like proof of identity, address, and income. These documents are vital for verifying your profile.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-pink-500" />,
      title: "Get Redirected to Bank Website",
      description:
        " After document submission on TheFinMaster, you'll be securely redirected to the card issuer’s official site to finalize your application.",
    },
    {
      icon: <FaTruck className="h-6 w-6 text-blue-600" />,
      title: " Verification & Delivery",
      description:
        " The bank conducts a verification process post-application. If approved, your cashback credit card is dispatched and typically reaches you within 7–10 working days.",
    },
    {
      icon: <FaThumbsUp className="h-6 w-6 text-green-500" />,
      title: "Choose the Right Match",
      description:
        " Based on your monthly expenses and lifestyle habits—like groceries, dining, online shopping, or utility payments—select a card that offers the most value for your money.",
    },
    {
      icon: <FaSearchDollar className="h-6 w-6 text-orange-500" />,
      title: " Compare Top Cashback Cards",
      description:
        " Begin by browsing a range of carefully evaluated cashback cards on TheFinMaster. Assess key features such as cashback categories, maximum cashback limits, annual fee structure, joining bonuses, and redemption flexibility.",
    },
  ];
  const benefits = [
    {
      icon: <FaMedal className="text-3xl text-amber-600" />,
      title: " Annual Fee Waiver Possibility",
      description:
        "Most cards offer annual fee waivers upon achieving a predefined yearly spend, making your card effectively free to use.",
    },

    {
      icon: <FaRegHandshake className="text-3xl text-purple-600" />,
      title: "Introductory Cashback Bonuses",
      description:
        " Many issuers offer attractive welcome benefits like flat cashback on your first few transactions or achieving a minimum spend threshold.",
    },
    {
      icon: <FaMoneyBillWave className="text-3xl text-yellow-500" />,
      title: "Direct Savings on Daily Purchases",
      description:
        " Whether you’re buying groceries, paying for fuel, or dining out, cashback cards reward you instantly by giving back a portion of your spend—ranging from 1% to 10% on select categories.",
    },
    {
      icon: <FaReceipt className="text-3xl text-pink-500" />,
      title: "Statement Credit or Direct Reimbursement",
      description:
        "Cashback earned is often adjusted directly against your card bill, simplifying the benefit process without any need for redemption.",
    },

    {
      icon: <FaLayerGroup className="text-3xl text-green-600" />,
      title: "Flexibility Across Categories",
      description:
        "Cards often offer tiered benefits—higher cashback on selected categories like online shopping and moderate on general spends, giving you optimized value.",
    },

    {
      icon: <FaGlobeAmericas className="text-3xl text-red-500" />,
      title: " EMI Conversions with Cashback Benefits",
      description:
        " Some cards allow you to convert large purchases into EMIs while still enjoying cashback benefits on the initial spend, maximizing affordability and returns.",
    },
  ];

  const factors = [
    {
      icon: FaMoneyCheckAlt,
      title: "Cashback Rate vs Spending Pattern",
      desc: " Analyze whether the card offers flat cashback or higher returns on select categories. Choose a card that complements your highest areas of spend.",
    },
    {
      icon: FaLayerGroup,
      title: " Maximum Cashback Limits",
      desc: " Most cards impose a monthly or annual cap on cashback earnings. Ensure that the cap is high enough to match your expected usage so you don't miss out.",
    },

    {
      icon: FaClipboardCheck,
      title: "Minimum Spend Requirements",
      desc: "Some cards require a minimum spend per month to unlock cashback. Make sure the card suits your financial habits so you don’t lose potential rewards.",
    },
    {
      icon: FaBalanceScale,
      title: "Fee vs Benefit Equation",
      desc: " Evaluate the joining and annual fees in relation to the total cashback you expect to earn annually. A high-fee card with higher cashback might outperform a free one depending on your usage.",
    },
    {
      icon: FaWallet,
      title: "Redemption and Crediting Process",
      desc: " Understand how and when cashback is credited. Prefer cards that offer automatic statement credits without delays or redemption thresholds.",
    },
    {
      icon: FaTags,
      title: "Partner Brand Offers",
      desc: " Look for exclusive tie-ups with merchants, apps, or platforms that enhance the cashback rate for specific spends, like Amazon, Flipkart, Swiggy, or Paytm.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
        Best Cashback Credit Cards in India – Save on Every Spend
        </title>
        <meta
          name="description"
          content="Compare top cashback credit cards for online shopping, groceries, fuel & more. Maximize savings and apply online now."
        />
        <meta
          name="keywords"
          content="cashback sbi credit card, best credit card for cashback rewards, top rated cash back credit cards, money back credit cards, highest cash rewards credit card, cash back on credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/best-cashback-credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>

      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            Cash Back
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>
        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-4 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-premium-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdStars className="mr-1 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Premium
              </span>
            </span>
          </Link>
            <Link
                      to="/credit-card/reward-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <FaGift className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        Reward
                        </span>
                      </span>
                    </Link>
                    <Link
                      to="/credit-card/business-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <FaBriefcase className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                        Business
                        </span>
                      </span>
                    </Link>
                    <Link
                      to="/credit-card/lifestyle-credit-card"
                      className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                    >
                      <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                      <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                        <svg
                          class="w-5 h-5 text-green-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          ></path>
                        </svg>
                      </span>
                      <span className="relative flex items-center">
                        <MdCardMembership className="mr-1 text-black text-2xl" />{" "}
                        <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                          LifeStyle
                        </span>
                      </span>
                    </Link>
        </div>

        <h2 className="text-center font-bold text-2xl md:text-3xl  my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          {currentCards && currentCards.length > 0 ? (
            <div className="w-fit flex flex-col gap-8">
              {currentCards.map((item, index) => (
                <CardComponent
                  key={index}
                  cardDetails={item}
                  Card_features={item?.Card_features}
                  fees={item?.fees}
                  cardName={item?.title}
                  cardImage={item?.image}
                  rating={item?.rating}
                  category={item?.category}
                  status={item?.status}
                  bank_link={item?.bank_link}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center">
              <img
                src="/path/to/error-image.png"
                alt="Error"
                className="w-32 h-32"
              />
              <p className="text-red-500 text-center">No cards available</p>
            </div>
          )}

          {/* <div className='w-fit flex flex-col gap-8'>
                    {
                        currentCards &&
                        currentCards.map((item, index) => {
                            return <> <CardComponent key={index} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
                        })
                    }
                </div> */}

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[300px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                <h2 className="text-center font-medium pt-5 text-lg">
                  <span className="font-semibold text-white">816 people</span>{" "}
                  are on call with our advisors right now
                </h2>
              </div> */}
              <div className="w-full mx-auto">
               
                  <div className="w-[80%] mx-auto ">
                    {/* <img
                      src="/assets/sidebanner.png"
                      alt="Advertisement"
                      target="_blank"
                      rel="noopener noreferrer"
                    /> */}
                     <AdBanner displayOrder="2" />
                  </div>
              
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                    Know your advisor
                  </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl  font-bold text-gray-800 ">
            What is a Cashback Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A cashback credit card is a type of credit card that rewards you by
            returning a percentage of your spending in the form of cash. Unlike
            reward points that require redemption, cashback is more
            straightforward and tangible, making it one of the most preferred
            types of credit cards among savvy spenders. These cards are ideal
            for everyday purchases, including groceries, fuel, dining, and
            online shopping, providing you with instant value every time you
            swipe.
          </p>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          📝 How to Apply for a Cashback Credit Card
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          The application process for a cashback credit card is seamless and can
          be initiated through TheFinMaster.com. Here’s how you can apply:{" "}
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
        </div>
      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl  font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for Cashback Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Identity Proof
                </span>
                <span>
                  {" "}
                  PAN card (mandatory), Aadhaar card, Passport, or Voter ID
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Address Proof
                </span>
                <span>
                  {" "}
                  Utility bill, Aadhaar card, Passport, or rental agreement
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Income Proof
                </span>
                <span>
                  {" "}
                  Salary slips (last 3 months), Bank statements (3-6 months), or
                  ITR for self-employed individuals
                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Photograph
                </span>
                <span> Recent passport-sized color photograph</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Employment Proof
                </span>
                <span> Offer letter or employee ID (in some cases)</span>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl  font-extrabold text-gray-800 dark:text-white">
                Eligibility Criteria to Apply for a Cashback Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  {" "}
                  Age
                </span>
                <span>
                  {" "}
                  Minimum of 21 years for salaried, and 25 years for
                  self-employed individuals.
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Nationality{" "}
                </span>
                <span>
                  {" "}
                  Indian resident or Non-Resident Indian (NRI) with valid proof{" "}
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Income Requirement
                </span>
                <span>
                  {" "}
                  ₹25,000/month or more for most cards; high-tier cards may
                  require ₹50,000+.{" "}
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Credit Score
                </span>
                <span> A CIBIL score of 700+ is typically preferred.</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  Employment Status
                </span>
                <span>
                  {" "}
                  Steady employment with income proof or a registered business
                  with income documentation.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto mt-4">
        <h2 className="text-2xl md:text-3xl  font-semibold text-gray-800 text-center mb-10">
          Benefits of a CashBack Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl  font-bold text-gray-900 text-center mb-6">
          How to Choose the Best Cashback Credit Card – Key Factors to Consider
        </h2>
        {/* <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
    Selecting the right fuel credit card goes beyond just fuel discounts. It’s about ensuring consistent savings, ease of use, and long-term value. Here are the key elements to evaluate before making your choice:
  </p> */}

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-2xl md:text-3xl  font-bold text-center mb-6">
          Why Opt for a Cashback Credit Card?
        </h2>

        <p className="text-base md:text-md text-center mb-14 max-w-4xl mx-auto text-gray-800">
          Cashback credit cards are ideal for individuals seeking immediate,
          practical rewards on everyday spending. If you're someone who uses
          your card regularly for household bills, grocery runs, fuel refills,
          or online shopping, a cashback card offers unmatched simplicity and
          value. Unlike travel or co-branded cards, which may suit niche
          audiences, cashback cards cater to a wider demographic—including
          working professionals, homemakers, students, and even small business
          owners. They are especially beneficial for those who prefer direct
          financial returns rather than reward systems requiring tracking and
          redemption.{" "}
        </p>

        {/* Comparison Table */}
        <h3 className="text-2xl md:text-3xl  font-semibold text-center mb-8">
          💳 Cashback Credit Cards vs Normal Credit Cards
        </h3>

        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                [
                  "Reward Type",
                  "Direct cashback credited to your account",
                  "Reward points, miles, or co-branded perk",
                ],
                [
                  "Ease of Use",
                  "Simple and transparent—no redemption needed",
                  "Often involves complex conversion and expiry rules",
                ],
                [
                  "Best For",
                  "Day-to-day purchases and savings",
                  "Specialized use cases like travel or brand loyalty",
                ],
                [
                  "Annual Fee Justification",
                  "Justified through cashback returns",
                  "Depends on redemption value of points",
                ],
                [
                  "Savings Potential",
                  "Immediate financial benefit",
                  "Deferred or redemption-based value",
                ],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-sm text-gray-700">
                    <p>
                      <span className="font-semibold">
                        Cashback Credit Card:
                      </span>{" "}
                      {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">Normal Credit Card:</span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                      Cashback Credit Card
                    </th>
                    <th className="px-4 py-3 font-semibold">
                      Normal Credit Card
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "Reward Type",
                      "Direct cashback credited to your account",
                      "Reward points, miles, or co-branded perk",
                    ],
                    [
                      "Ease of Use",
                      "Simple and transparent—no redemption needed",
                      "Often involves complex conversion and expiry rules",
                    ],
                    [
                      "Best For",
                      "Day-to-day purchases and savings",
                      "Specialized use cases like travel or brand loyalty",
                    ],
                    [
                      "Annual Fee Justification",
                      "Justified through cashback returns",
                      "Depends on redemption value of points",
                    ],
                    [
                      "Savings Potential",
                      "Immediate financial benefit",
                      "Deferred or redemption-based value",
                    ],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CashBack;

// import React, { useEffect, useState } from 'react'
// import CardComponent from '../cardComponents/CardComponent'
// import AccordionComponent from '../accordion/AccordionComponent'
// // import { CreditCardData } from './CardData'
// import Http from '../../Http'
// import { CARD_API } from '../../Helper'
// import { Link, useLocation } from 'react-router-dom'
// const CashBack = () => {
//     const [CreditCardData,setCreditCardData] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const [cardsPerPage] = useState(10);
//     const location = useLocation();
//     const cardData = location.state;
//     console.log(cardData, location.state)

//     const indexOfLastCard = currentPage * cardsPerPage;
//     const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//     console.log({indexOfLastCard,indexOfFirstCard})
//     console.log({cardData})
//     const currentCards = Array.isArray(cardData) && cardData.filter((cards)=>cards.category_name==="Cash Back").slice(indexOfFirstCard, indexOfLastCard);
//     console.log({currentCards})
//     // const currentCards = CreditCardData.cards?.filter((card)=>card.category_name==="Cash Back").slice(indexOfFirstCard, indexOfLastCard);
//     // console.log({currentCards})

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <div className='w-full flex flex-col items-center '>

//             <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
//                 <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
//                     Cash Back Card
//                 </h1>
//                 <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
//                 {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}

//             </div>

//             <h1 className='text-center font-bold text-5xl my-10'>Featured Credit Cards</h1>
//             <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10'>
//                 <div className='w-fit flex flex-col gap-8'>
//                     {
//                         currentCards &&
//                         currentCards.map((item, index) => {
//                             return <> <CardComponent key={index} cardDetails={item} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
//                         })
//                     }
//                 </div>

//                 <div className='w-full relative '>
//                     <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
//                         <div className='w-[70%] mx-auto'>
//                             <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
//                         </div>
//                         <div className='w-full mx-auto'>
//                             <div className='w-[70%] mx-auto'>
//                                 <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
//                             </div>
//                             <div className='bg-white'>
//                                 <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             </div>
//                    {/* Pagination */}
//                    <ul className='flex justify-center mt-4'>
//                 {currentCards &&
//                      CreditCardData.cards?.filter((card)=>card.category==="Credit card").length > 0 &&
//                     Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) > 1 &&
//                     Array.from({ length: Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) }).map((_, index) => (
//                         <li key={index} className='mx-1'>
//                             <button
//                                 className={`px-3 py-1 rounded-lg ${
//                                     currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
//                                 }`}
//                                 onClick={() => paginate(index + 1)}
//                             >
//                                 {index + 1}
//                             </button>
//                         </li>
//                     ))}
//             </ul>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//     )
// }

// export default CashBack
